import { NavLink } from "react-router-dom";
import logo from "../assets/logo/logo.png";
import { CONTACT_CONFIG } from "../config/contact";

export default function Header() {
  // Utilisation des variables de configuration centralisées
  const { phoneNumber: PHONE_NUMBER, whatsappUrl: WHATSAPP_URL } = CONTACT_CONFIG;
  return (
    <>
      <header className="bg-white py-3 sticky top-0 z-50 shadow-sm border-b border-gray-200">
        <div className="w-[90%] sm:w-[90%] md:w-[85%] lg:w-[85%] m-auto flex items-center justify-between">
          <div className="flex justify-start items-center">
            {/* Logo */}
            <NavLink to="/" className="flex items-center flex-shrink-0">
              <img
                src={logo}
                alt="logo"
                className="w-10 h-auto md:w-12 md:h-auto"
              />
            </NavLink>
          </div>

          {/* Desktop Right Side */}
          <div className="hidden lg:flex items-center gap-6">
            {/* WhatsApp */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[#25d366] hover:text-[#128C7E] transition-colors duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18px"
                height="18px"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222c0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222c0-59.3-25.2-115-67.1-157m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4l-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2c0-101.7 82.8-184.5 184.6-184.5c49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6m101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18c-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4c-32.6-16.3-54-29.1-75.5-66c-5.7-9.8 5.7-9.1 16.3-30.3c1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5c-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8c35.2 15.2 49 16.5 66.6 13.9c10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6"
                ></path>
              </svg>
              <span className="text-sm font-medium">{PHONE_NUMBER}</span>
            </a>

            {/* PRECIOS Button */}
            <a
              href="#pricing"
              className="bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 text-white font-bold text-sm py-2.5 px-6 rounded-lg transition-all duration-300 hover:scale-105 shadow-md"
            >
              EMPEZAR
            </a>
          </div>

          {/* Mobile/Tablet Layout - Like second image */}
          <div className="lg:hidden flex items-center gap-3">
            {/* WhatsApp Contact */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-50 text-[#25d366] px-3 py-2 rounded-lg border border-green-200 hover:bg-green-100 transition-colors duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16px"
                height="16px"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222c0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222c0-59.3-25.2-115-67.1-157m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4l-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2c0-101.7 82.8-184.5 184.6-184.5c49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6m101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18c-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4c-32.6-16.3-54-29.1-75.5-66c-5.7-9.8 5.7-9.1 16.3-30.3c1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5c-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8c35.2 15.2 49 16.5 66.6 13.9c10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6"
                ></path>
              </svg>
              <span className="text-xs font-medium">{PHONE_NUMBER}</span>
            </a>

            {/* PRECIOS Button */}
            <a
              href="#pricing"
              className="bg-gradient-to-r from-[#04003b] via-[#090979] to-[#00d4ff] hover:brightness-110 text-white font-bold flex items-center justify-center text-xs py-2.5 px-4 rounded-lg transition-all duration-300 hover:scale-105 shadow-md"
            >
              EMPEZAR
            </a>
          </div>
        </div>
      </header>
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <div className="relative">
          {/* Concentric circles for pulsing effect */}
          <div className="absolute inset-0 bg-[#25d366] rounded-full animate-ping opacity-20"></div>
          <div
            className="absolute inset-0 bg-[#25d366] rounded-full animate-ping opacity-15"
            style={{ animationDelay: "0.5s" }}
          ></div>
          <div
            className="absolute inset-0 bg-[#25d366] rounded-full animate-ping opacity-10"
            style={{ animationDelay: "1s" }}
          ></div>

          {/* Main WhatsApp button */}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="relative bg-[#25d366] hover:bg-[#128C7E] text-white w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 border-4 border-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 448 512"
            >
              <path
                fill="currentColor"
                d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222c0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222c0-59.3-25.2-115-67.1-157m-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4l-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2c0-101.7 82.8-184.5 184.6-184.5c49.3 0 95.6 19.2 130.4 54.1s56.2 81.2 56.1 130.5c0 101.8-84.9 184.6-186.6 184.6m101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18c-5.1-1.9-8.8-2.8-12.5 2.8s-14.3 18-17.6 21.8c-3.2 3.7-6.5 4.2-12 1.4c-32.6-16.3-54-29.1-75.5-66c-5.7-9.8 5.7-9.1 16.3-30.3c1.8-3.7.9-6.9-.5-9.7s-12.5-30.1-17.1-41.2c-4.5-10.8-9.1-9.3-12.5-9.5c-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.6-19.4 19-19.4 46.3s19.9 53.7 22.6 57.4c2.8 3.7 39.1 59.7 94.8 83.8c35.2 15.2 49 16.5 66.6 13.9c10.7-1.6 32.8-13.4 37.4-26.4s4.6-24.1 3.2-26.4c-1.3-2.5-5-3.9-10.5-6.6"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </>
  );
}
